import React, { useContext, useEffect, useState } from 'react';
import { flushSync } from 'react-dom';
import { useHistory, useParams } from 'react-router-dom';
import utilsOrders from '../../../../../MyConns/_Utils/utilsOrders';
import OrderFunctions from '../../../../../MyFunctions/OrderFunctions';
import PrintingStyle from '../../../../../MyFunctions/PrintingStyle';
import MyDateTime from '../../../../MySections/TimeSections/MyDateTime';
import SucessToast from '../../../../MySections/Toasts/SucessToast';
import Breadcrumb from './Breadcrumb';

import { Button } from '@mui/material';
import parse from 'html-react-parser';
import TextBoxSet from '../../../../MySections/PopUps/TextBoxSet';
import OrderStatuselect from '../../OrdersList-list/OrderStatuselect';
import InvoiceMobiTable from './InvoiceMobiTable';
import InvoicePrint from './InvoicePrint';
import InvoiceTable from './InvoiceTable';


import Translator from '../../../../../MyFunctions/Translator';
import { ScreenWidthContext } from '../../../../MyContexts/ScreenWidth_Context';
import MySpinner_Wait from '../../../../MySections/DTechComps/MySpinner_Wait';
import UpdateOrderDetails from '../../../../MySections/PopUps/UpdateOrderDetails';
import { faBullseye } from '@fortawesome/free-solid-svg-icons';


const Content = (props) => {

    const [screenWidth, setScreenWidth] = useContext(ScreenWidthContext);
    const [loading, setLoading] = useState(true);
    const [theOrder, setTheOrder] = useState([]);
    const [times, setTimes] = useState([]);
    const [printMe, setPrintMe] = useState([false]);
    const [thePopUp, setThePopUp] = useState("");
    const [arabic, setArabic] = useState("عربيه");
    const [timerInterv, setTimerInterv] = useState(null);
    const [forKitchen, setForkitchen] = useState(false);

    let idParam = useParams();

    const history = useHistory();


    useEffect(() => {
        loadTheOrder();
    }, [])


    const loadTheOrder = async () => {
        if (idParam.id) {
            let Orderloaded = await utilsOrders.getOrder(idParam.id);
            setTheOrder(Orderloaded);
            getTimes(Orderloaded)
            setLoading(false);
        }
        else {
            history.push("/Orders");
        }

    }

    const getTimes = (ord) => {
        if (timerInterv != null) {
            clearInterval(timerInterv)
        }

        setTimerInterv(setInterval(() => {
            let theItm = MyDateTime.getTimeLeftBetweenTimes(new Date(), ord.dateToDeliver);
            setTimes(theItm)

        }, 1000))
    }

    const updateTheOrder = async () => {

        let updteme = await utilsOrders.updateOrder(theOrder._id, theOrder);
        loadTheOrder();
        SucessToast({ position: "toast-bottom-right", text: "עודכן בהצלחה!" });
    }

    const getAddress =
        <>
            <div><span className="bold">עיר: </span>
                <span>{theOrder.deliveryAddress?.city}</span>
            </div>
            <div className="fullRow">
                <div className="onRight">
                    <span className="bold">רחוב: </span>
                    <span>{theOrder.deliveryAddress?.street}</span>
                </div>
                <div className="onRight spaceMargeRight_10">
                    <span className="bold">מספר: </span>
                    <span>{theOrder.deliveryAddress?.num}</span>
                </div>
            </div>

            <div className="fullRow">
                {theOrder.deliveryAddress?.appartment &&
                    theOrder.deliveryAddress?.appartment !== "" &&
                    <div className="onRight">
                        <span className="bold">דירה: </span>
                        <span>{theOrder.deliveryAddress?.appartment}</span>
                    </div>
                }
                {theOrder.deliveryAddress?.ent &&
                    theOrder.deliveryAddress?.ent !== "" &&
                    <div className="onRight spaceMargeRight_10">
                        <span className="bold">כניסה: </span>
                        <span>{theOrder.deliveryAddress?.ent}</span>
                    </div>
                }
            </div>
            <div className="fullRow">
                {theOrder.deliveryAddress?.flor &&
                    theOrder.deliveryAddress?.flor !== "" &&
                    <div className="onRight">
                        <span className="bold">קומה: </span>
                        <span>{theOrder.deliveryAddress?.flor}</span>
                    </div>
                }
                {theOrder.deliveryAddress?.remarks &&
                    theOrder.deliveryAddress?.remarks !== "" &&
                    <div className="onRight spaceMargeRight_10">
                        <span className="bold">הערות: </span>
                        <span>{theOrder.deliveryAddress?.remarks}</span>
                    </div>
                }
            </div>
        </>;



    const clientDetails =
        <>
            <div className={"spac spacePadBig specialRow"}>
                <div className={"bold"}>שם הלקוח: {theOrder.user?.firstName}  {theOrder.user?.lastName}</div>
                <div className={"bold"}>טלפון: {theOrder.user?.phone}</div>
                {theOrder.user?.email != "" ? <div className={"bold"}>אימייל: {theOrder.user?.email}</div> : ""}
                {
                    theOrder.user?.parentUser ? <div className={"bold"}>נוצר על ידי : {theOrder.user?.parentUser.firstName + " " + theOrder.user?.parentUser.lastName}</div> : ""
                }
            </div>

        </>;


    const popUpdateOrder = () => {
        setThePopUp(
            <UpdateOrderDetails Title={"עריכת פרטים"}
                theOrder={theOrder} inLabel={""}
                okClick={(theOrderBk) => popMe(theOrderBk)}
                cancelClick={() => setThePopUp()}
                errorMsg={""}
            />)


    }
    const popMe = (theOrderBk) => {
        setTheOrder(theOrderBk)
        console.log(theOrderBk)
        updateTheOrder();
    }

    const printIt = (kitchornot) => {
        flushSync(() => {
          setForkitchen(kitchornot);
        });
        setPrintMe(true);
        // Now the state is updated synchronously
        var content = document.getElementById("printingCloser");
        var pri = document.getElementById("ifmcontentstoprint").contentWindow;
        pri.document.open();
        pri.document.write(PrintingStyle.mediaprint() + content.innerHTML);
        pri.document.close();
        pri.focus();
        pri.print();
        setPrintMe(false);
      };
 

    const ShowInArab = () => {
        if (arabic == "عربيه") {
            setArabic("עברית");
            setTheOrder(Translator.Arabic(theOrder));

        } else {
            setArabic("عربيه");
            setTheOrder(Translator.BackToHeb(theOrder));
        }
    }

    const setNewStatus = async (orderId, statBack) => {

        let updteme = await utilsOrders.updateStatus(orderId, statBack);
        loadTheOrder();

    }

    const setRemarks = () => {
        setThePopUp(
            <TextBoxSet Title={"הערות הזמנה"}
                textFirst={theOrder.orderRemarks} inLabel={""}
                okClick={(textBack) => setRemarksApprov(textBack)}
                cancelClick={() => setThePopUp()}
                errorMsg={""}
            />)
    }


    const setRemarksApprov = (textBack) => {
        // alert(textBack)


        theOrder.orderRemarks = textBack;

        setTheOrder(theOrder);
        getTimes(theOrder)

    }

    const addOrderItem = () => {
        setThePopUp(
            // <RestMnu buisMenu={restPage.buisMenu} nameBuis={restPage.buissName} restPage={restPage}
            //     doDeliver={temp_doDeliver}
            //     doTakeAway={temp_doTakeAway}
            //     setShowHideMoreDet={() => setShowHideMoreDet("showOnLeft")}
            //     dispOnlyDelivery={dispOnlyDelivery} BuisId={restPage._id}
            //     setDispOnlyDelivery={() => setDispOnlyDelivery(!dispOnlyDelivery)} />

        )



    }


    return (
        loading ? <MySpinner_Wait /> :
            <>
                <div className="no_print">
                    <div className="ms-content-wrapper">
                        <div className={`row no_print`}>
                            <div className="col-md-12">
                                <div><Breadcrumb /></div>
                                <div className="ms-panel theOrderwrap">
                                    <div className={"onRight spaceMargeTopbig spaceMargeRightbig"}>
                                        <Button className={"btnMediumMnu"} variant="contained" onClick={() => history.push('/Orders')}>
                                            לכל ההזמנות
                                        </Button>
                                    </div>

                                    <div className="onLeft spaceMargeTopbig spaceMargeRightbig">
                                        <Button className={"btnMediumMnu"} variant="contained" onClick={() => printIt(false)}>
                                            הדפס הזמנה
                                        </Button>

                                    </div>
                                    <div className="onLeft spaceMargeTopbig spaceMargeRightbig">
                                        <Button className={"btnMediumMnu"} variant="contained" onClick={() => printIt(true)}>
                                            הדפס למטבח
                                        </Button>

                                    </div>
                                    {/* {theOrder.rst.arabic ? <>
                                        <div className="onLeft spaceMargeTopbig spaceMargeRightbig">
                                            <Button className={"btnMediumMnu"} variant="contained" onClick={() => ShowInArab()}>
                                                {arabic}
                                            </Button>

                                        </div>
                                    </> : ""} */}
                                    <div className="ms-panel-header header-mini centerText fullRow">
                                        <h3 className={"spaceMargeTopbig"}>{`הזמנה ${theOrder?.orderNUM}`}</h3>
                                    </div>

                                    <div className="col-md-12 overflowHid">
                                        <div className={"bold big fullRow"}>מועד המסירה:
                                            יום {MyDateTime.getDayOfWeekHeb(theOrder?.dateToDeliver)} {MyDateTime.getDate(theOrder?.dateToDeliver)},
                                            בשעה {MyDateTime.getShortTime(theOrder?.dateToDeliver)}</div>

                                        <div className="ms-panel-header header-mini col-md-6 onRight">
                                            <div className={"grayFrame"}>
                                                {/* <div className="d-flex justify-content-between onRight spaceMargeTopbig">
                                                <h6>{`הזמנה #${theOrder?.orderNUM}`}</h6>
                                            </div> */}
                                                {/* <div className={"onLeft spaceMargeTopbig spaceMargeRightbig"}>
                                                <Button className={"btnMediumMnu"} variant="contained" onClick={() => popUpdateOrder()}>
                                                    ערוך פרטים
                                                </Button>
                                            </div>
                                            <br /> */}
                                                <h4 className="DelORGet d-flex justify-content-between bold fullRow">
                                                    {(theOrder?.OrderType !== "Take") ? "משלוח" : "איסוף"}
                                                </h4>

                                                <div className={"col-md-12"}>
                                                    <div className="invoice-address">
                                                        {/* {(theOrder?.OrderType == "Deliver") ?
                                                            getAddress : ""} */}
                                                        {(theOrder?.OrderType !== "Take") &&
                                                            <>
                                                                {getAddress}
                                                                <div className={"grayLineBoottom"}></div>
                                                            </>
                                                        }
                                                        {clientDetails}
                                                        {/* <div className={"spaceMargeTopbig"}>
                                                        <Button className={"btnMediumMnu"} variant="contained" onClick={() => setRemarks()}>הערות</Button>
                                                    </div> */}

                                                        {(theOrder?.orderRemarks != null && theOrder?.orderRemarks != "") &&
                                                            <>
                                                                <div className={"grayLineBoottom"}></div>
                                                                <div>הערות:</div>
                                                                {/* <div className={"pointing"} onClick={() => setRemarks()}> */}
                                                                <div className={"pointing"} >
                                                                    <div className="big bold">{(theOrder?.orderRemarks != null) ? parse(`${theOrder.orderRemarks}`) : ""} </div>
                                                                </div>

                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <h6 className="d-flex justify-content-between bold fullRow">
                                                אופן תשלום: {OrderFunctions.payingTYpe(theOrder)}
                                            </h6>

                                            <h6 className="d-flex justify-content-between bold fullRow">
                                                סטטוס תשלום: {theOrder?.paymentStatus}
                                            </h6>


                                        </div>

                                        <div className="ms-panel-header header-mini col-md-6 onRight dirLeft">
                                            <div className={"grayFrame"}>
                                                <div className="fullRow">
                                                    <div className={"bold centerText"}>יצירת ההזמנה: {MyDateTime.getDateAndTime(theOrder?.dateCreated)}</div>
                                                </div>

                                                {(theOrder?.lastUpdate) ? <>
                                                    <div className="fullRow">
                                                        <div className={"bold centerText "}>עדכון אחרון: {MyDateTime.getDateAndTime(theOrder?.lastUpdate)}</div>
                                                    </div>
                                                    <div className="fullRow">
                                                        <div className={"bold centerText "}>עודכן ע"י: {theOrder?.lastUpdaterBy || ""}</div>
                                                    </div>
                                                </>
                                                    : ""}

                                                {(theOrder?.dateClosed) ? <>
                                                    <br />
                                                    <div className="fullRow">
                                                        <div className={"bold centerText"}>סגירת ההזמנה: {MyDateTime.getDateAndTime(theOrder?.dateClosed)}</div>
                                                    </div>
                                                    <br />

                                                    <div className="fullRow">
                                                        <div className={"bold centerText"}>נסגר על ידי: {theOrder?.closedBY}</div>
                                                    </div>

                                                </>
                                                    : ""}
                                            </div>
                                            <div className={"grayFrame"}>
                                                <div className="fullRow">
                                                    <div className={"statBlock"}>
                                                        <div className="bold onRight">
                                                            סטטוס הזמנה:
                                                        </div>
                                                        <div className={"statusCell pointing onRight veryBig"} >
                                                            <OrderStatuselect orderStatus={theOrder?.orderStatus}
                                                                setOrderStatus={(statBack) => setNewStatus(theOrder?._id, statBack)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="fullRow">
                                                    {
                                                        (times.theEnd) ?
                                                            ((theOrder?.orderStatus != "סגור") ?

                                                                <div className={"myButton"} style={{ backgroundColor: times.theCol, color: times.theForCol, fontWeight: "bold", margin: "0 auto" }} id={theOrder?._id + "_Count"}>
                                                                    <div className={"fullRow"}>הסתיים הזמן לפני</div>
                                                                    <div id={theOrder?._id + "_Cnt"}>
                                                                        {times.theTm}<br />
                                                                        {/* {MyDateTime.getTimeLeftTilThen( theOrder.dateCreated,  theOrder.OrderTimes)} */}
                                                                    </div>
                                                                    {/* {counterDown( theOrder._id)} */}
                                                                </div>
                                                                : "") :

                                                            <div className={"myButton"} style={{ backgroundColor: times.theCol, color: times.theForCol, fontWeight: "bold", margin: "0 auto" }} id={theOrder?._id + "_Count"}>
                                                                <div>זמן לביצוע</div>
                                                                <div id={theOrder?._id + "_Cnt"}>
                                                                    {times.theTm}<br />
                                                                    {/* {MyDateTime.getTimeLeftTilThen( theOrder.dateCreated,  theOrder.OrderTimes)} */}
                                                                </div>
                                                                {/* {counterDown( theOrder._id)} */}
                                                            </div>

                                                    }
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className={"col-md-12 overflowHid spaceMargeTopbig textLeft"} title={"הוסף מוצר"}>
                                        <Button className={"btnMediumMnu"} variant="contained" onClick={() => addOrderItem()}>+</Button>
                                    </div> */}
                                    {screenWidth > 800 ?
                                        <InvoiceTable theOrder={theOrder} arabic={(arabic == "עברית") ? true : false} /> :
                                        <InvoiceMobiTable theOrder={theOrder} arabic={(arabic == "עברית") ? true : false} />}
                                </div>
                            </div>
                        </div>

                        <div className="ms-panel-header approveLine no_print">
                            <button type="button" className="onLeft btn btn-primary spaceMargeTopbig" onClick={() => updateTheOrder()}>שמור</button>
                        </div>

                    </div>
                    {thePopUp}
                </div >

                <div id={"printingCloser"} className="onlyOnPrint printingCloser">
                    {/* <div id={"printingCloser"} className="printingCloser"> */}
                    <InvoicePrint theOrder={theOrder} arabic={(arabic == "עברית") ? true : false} forKitchen={forKitchen} />
                </div>
              
                <iframe id={"ifmcontentstoprint"}></iframe>
            </>

    );

}


export default Content;
